module.exports = __webpack_public_path__ + "static/media/7.67f6b37c.png";